module.exports = __webpack_public_path__ + "img/routine.56342954.png";